import { request } from './http'

export function login(username, password) {
  return request('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password })
  })
}

export function fetchCurrentUser() {
  return request('/api/auth/me')
}
